import * as React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardStyle } from './Card';

export interface PublicGuideCardProps {
  name: string;
  owner: string;
  method: string;
  url: string;
  grind_size: string;
  coffee: string;
  water: string;
}

export const GuideStatsInfo = (props: any) => (
  <ul className="flex justify-between tc ma0 pa0 ph4-l">
    <li className="flex flex-column black b f4">
      <h6 className="h2 ma0 lh-copy f6 ttu black-40 ttu">Grind Size</h6>
      {props.grind_size}
    </li>
    <li className="flex flex-column black b f4">
      <h6 className="h2 ma0 lh-copy f6 ttu black-40 ttu">Coffee</h6>
      {props.coffee}
    </li>
    <li className="flex flex-column black b f4">
      <h6 className="h2 ma0 lh-copy f6 ttu black-40 ttu">Water</h6>
      {props.water}
    </li>
  </ul>
);

export const PublicGuideCard = ({
  name,
  owner,
  method,
  url,
  ...props
}: PublicGuideCardProps) => (
  <Card
    className={`${CardStyle.Blank} animated fadeIn grow`}
    innerStyle={
      'flex flex-column justify-between absolute bottom-0 left-0 right-0 top-0 items-center ma2-l'
    }
  >
    <Link
      to={url}
      className="bg-near-white link black flex flex-column justify-between absolute bottom-0 left-0 right-0 top-0 items-center pa4"
    >
      <h6 className="h1 ma0 lh-copy f6 ttu black-70">{owner}</h6>
      <h3 className="h2 f3 ma0">{name}</h3>
      <div>
        <img
          className="w4 h4 br-100 dib"
          src={`/images/methods/${method}.png`}
          alt={name}
        />
      </div>
      <div className="h3 w-100">
        <GuideStatsInfo {...props} />
      </div>
    </Link>
  </Card>
);

export default PublicGuideCard;
